document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("scroll-featured-collection")) {
    customElements.define(
      "scroll-featured-collection",
      class ScrollFeaturedCollection extends HTMLElement {
        constructor() {
          super();
          this.tabs = this.querySelectorAll(
            ".tab_featured_collection_title_item"
          );
          this.tabContent = this.querySelectorAll(
            ".scroll-featured-collection-content"
          );
          this.tabsContainer = this.querySelector(
            ".tab_featured_collection_content"
          );

          this.desktopNum = this.getAttribute("data-desktop-num");
          this.mobileNum = this.getAttribute("data-mobile-num");
          this.spacing = this.getAttribute("data-spacing");
          this.isAutoplay = this.getAttribute("data-auto-play");
          this.isShowOppo = this.getAttribute("data-is-show-oppo");
          this.pageinationType = this.getAttribute("data-pageination-type");
          this.autoplayDelay = this.getAttribute("data-autoplay-delay");
        }

        connectedCallback() {
          this.initTabs();
          this.initSwipers();
        }

        initSwipers() {
          console.log(
            "this ..........attr..........",
            this.isAutoplay,
            this.isShowOppo,
            this.isShowPageination,
            this.isShowPregress
          );

          this.tabContent.forEach((item) => {
            // let _swiperContent = item.querySelector('.sfc_swiper');
            // let _collecitonId = _swiperContent.getAttribute('data-')
            let _colectionId = item.getAttribute("data-collection-id");
            let _sectionId = item.getAttribute("data-section-id");
            console.log(_colectionId);
            this.initSwiper(_colectionId,_sectionId);
          });
        }

        initSwiper(_colectionId,_sectionId) {
          console.log("collectionId::::::", _colectionId);

          let attrs = {
            observer: true,
            observeParents: true,
            slidesPerView: this.isShowOppo == "true" ? 1.8 : 2,
            spaceBetween:
              this.isShowOppo == "true"
                ? parseInt(this.spacing) / 2
                : parseInt(this.spacing) / 2,
            initialSlide: this.isShowOppo == "true" ? 1 : 0,
            centeredSlides: this.isShowOppo == "true" ? true : false,
            centeredSlidesBounds: true,
            breakpoints: {
              989: {
                slidesPerView: this.desktopNum,
                initialSlide:
                  this.isShowOppo == "true"
                    ? Math.floor(this.desktopNum / 2)
                    : 0,
                spaceBetween:
                  this.isShowOppo == "true"
                    ? parseInt(this.spacing) / 1.5
                    : parseInt(this.spacing),
                centeredSlides: this.isShowOppo == "true" ? true : false,
                centeredSlidesBounds: true,
              },
            },

            // 如果需要前进后退按钮
            navigation: {
              nextEl: `.swiper-button-next-${_colectionId}`,
              prevEl: `.swiper-button-prev-${_colectionId}`,
            },
          };
          console.log("aaaaa.....", this.isAutoplay);
          if (this.isAutoplay == "true") {
            console.log("autoplay::::::::::::true");
            attrs.autoplay = {
              disableOnInteraction: false,
              delay: parseInt(this.autoplayDelay) * 1000,
            };
          }
          // 如果需要分页器
          if (this.pageinationType != "no") {
            console.log("0909090", this.pageinationType);
            switch (this.pageinationType) {
              case "point":
                attrs.pagination = {
                  el: `.swiper-pagination-${_colectionId}`,
                  type: "bullets",
                  clickable: "true",
                };
                break;
              case "number":
                attrs.pagination = {
                  el: `.swiper-pagination-${_colectionId}`,
                  type: "fraction",
                };
                break;
              case "progress":
                attrs.pagination = {
                  el: `.swiper-pagination-${_colectionId}`,
                  type: "progressbar",
                };
                break;
            }
          }
          // 如果需要滚动条
          if (this.isShowPregress == "true") {
            attrs.scrollbar = {
              el: `.swiper-scrollbar-${_colectionId}`,
              type: "progressbar",
            };
          }

          console.log(attrs);

          new Swiper(`.swiper-${_colectionId}-${_sectionId}`, attrs);
        }

        initTabs() {
          this.tabs.forEach((tab) => {
            tab.addEventListener("click", (e) => this.handleTabClick(e));
          });
        }

        handleTabClick(e) {
          const tab = e.currentTarget;
          const index = [...this.tabs].indexOf(tab);

          this.tabs.forEach((t) => t.classList.remove("tab_item_active"));
          this.tabContent.forEach((c) =>
            c.classList.remove("tab_content_active")
          );
          tab.classList.add("tab_item_active");
          this.tabContent[index].classList.add("tab_content_active");

          this.scrollToCenter(tab); // 居中滚动
        }

        // 始终居中
        scrollToCenter(activeTab) {
          const container = this.tabsContainer;
          const containerRect = container.getBoundingClientRect();
          const tabRect = activeTab.getBoundingClientRect();

          // 计算需要滚动的距离（相对容器坐标系）
          const targetScroll =
            container.scrollLeft +
            (tabRect.left - containerRect.left) -
            containerRect.width / 2 +
            tabRect.width / 2;

          // 计算最大允许滚动位置
          const maxScroll = container.scrollWidth - container.clientWidth;

          // 边界修正
          const clampedScroll = Math.max(0, Math.min(targetScroll, maxScroll));

          // 执行滚动
          container.scrollTo({
            left: clampedScroll,
            behavior: "smooth",
          });
        }
      }
    );
  }
});
